<template>
    <div class="layout-container">
        <!-- 左侧固定导航 -->
        <div class="fixed-sidebar">
            <div class="sidebar-item" @click="backToTop">
                <i class="icon-top"></i><span>返回顶部</span>
            </div>
            <div class="sidebar-item" @click="scrollToElement('waterScheduling')"><span>水务调度</span></div>
            <div class="sidebar-item" @click="scrollToElement('riverLakeManagement')"><span>河湖管理</span></div>
            <div class="sidebar-item" @click="scrollToElement('drainageManagement')"><span>排水管理</span></div>
        </div>
        <div class="banner">
            建设盱眙特色“智慧管网”,驱动盱眙水务现代化管理
        </div>

        <div class="index-content">
            <div class="index-img-div1">
                <div class="index-top-content">
                    <div v-for="item in list" :key="item.label" class="index-top-item" :style="{ background: item.background }">
                        <div class="index-top-item-label">{{ item.label }}</div>
                        <div class="index-top-item-value">{{ item.value }}</div>
                        <div>{{ item.unit }}</div>
                    </div>
                </div>
                <div class="menu-info">
                    <div @click="$router.push('/')" class="menu-bg float-animation" style="background: url('/index/menu4.png') no-repeat center center; background-size: contain; width: 8.3vw; height:8.3vw;font-size: 1.6vw; top:120px; right: 200px;">
                        驾驶舱
                    </div>
                    <div @click="$router.push('/gis')" class="menu-bg float-animation" style="background: url('/index/menu1.png') no-repeat center center; background-size: contain; width: 7vw; height:7vw;font-size: 1.2vw; animation-delay: 0.2s; top:300px; right: 150px;">
                        管网GIS
                    </div>
                    <div @click="$router.push('/detection')" class="menu-bg float-animation" style="background: url('/index/menu2.png') no-repeat center center; background-size: contain; width: 7.5vw; height:7.5vw;font-size: 1.2vw; animation-delay: 0.5s; top:140px; left: 180px;">
                        管网检测
                    </div>
                    <div @click="$router.push('/expert-diagnosis-report')" class="menu-bg float-animation" style="background: url('/index/menu3.png') no-repeat center center; background-size: contain; width: 7.2vw; height:7.2vw;font-size: 1.2vw; animation-delay: 0.2s; top:230px; left:10px;">
                        专家诊断
                    </div>
                    <div @click="$router.push('/assets')" class="menu-bg float-animation" style="background: url('/index/menu5.png') no-repeat center center; background-size: contain; width: 7.5vw; height:7.5vw;font-size: 1.2vw; animation-delay: 0.4s; top:330px; left: 140px;">
                        管网管理
                    </div>
                    <div @click="$router.push('/pipe-info')" class="menu-bg float-animation" style="background: url('/index/menu4.png') no-repeat center center; background-size: contain; width: 7.5vw; height:7.5vw;font-size: 1.2vw; animation-delay: 0.3s; top:380px; right: 20px;">
                        资产管理
                    </div>
                </div>
                <div class="menu-info-content">
                    <img class="index-img1" src="/index/pedestal.png" alt=""/>
                </div>
            </div>
        </div>

        <div class="emergency-response-container">
            <!-- 水务调度 -->
            <div class="emergency-title" ref="waterScheduling">
                <span class="icon"></span>
                <span class="text">水务调度</span>
            </div>
            <div class="emergency-response">
                <div class="emergency">
                    <div class="emergency-subtitle">应急响应</div>
                    <div class="emergency-areas">
                        <div class="emergency-area-item">
                            <div class="emergency-area-item-status">未启动</div>
                            <div>全县</div>
                        </div>
                        <div v-for="item in emergencyArea" :key="item.item" class="emergency-area-item"
                             :style="item.value === 1 ? { 'background': 'linear-gradient(135deg, #00ff96, #00d4ff)', 'color': '#0a0e27' } : {}">
                            <div class="emergency-area-item-status" :style="item.value === 1 ? {'color': '#0a0e27' } : {}">{{ item.value == 0 ? '未启动' : '启动' }}</div>
                            <div>{{ item.item }}</div>
                        </div>
                    </div>
                </div>
                <div class="emergency">
                    <div class="emergency-subtitle">防汛值班</div>
                    <div class="emergency-duty">
                        <div class="flood-control-duty">
                            <div class="flood-control-duty-today">今 日 值 班</div>
                            <div class="flood-control-duty-tomorrow">明 日 值 班</div>
                        </div>
                        <div class="flood-control-duty-detail">
                            <div class="flood-control-duty-detail-item">
                                <div><div>值班领导</div><div class="flood-control-duty-detail-item-name">张三</div></div>
                                <div><div>值班组员</div><div class="flood-control-duty-detail-item-name">张三</div></div>
                            </div>
                            <div class="flood-control-duty-detail-item">
                                <div><div>值班领导</div><div class="flood-control-duty-detail-item-name">张三</div></div>
                                <div><div>值班组员</div><div class="flood-control-duty-detail-item-name">张三</div></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="emergency">
                    <div class="emergency-subtitle">气象信息</div>
                    <div class="emergency-wea">
                        <div v-if="weatherList.length > 0" class="wea">{{ weatherList[0].tem }}℃</div>
                        <div v-else class="wea">暂无数据</div>
                        <div v-if="weatherList.length > 0" class="wea">{{ weatherList[0].wea }}</div>
                        <div v-else class="wea">暂无数据</div>
                        <div v-if="weatherList.length > 0" class="wea-area">{{ weatherList[0].date }}</div>
                        <div v-else class="wea-area">暂无数据</div>
                        <div v-if="weatherList.length > 0" class="wea-area">{{ weatherList[0].week }}</div>
                        <div class="wea-area">盱眙</div>
                    </div>
                    <div style="margin:3vh 0;">
                        <div v-for="(item, index) in weatherList" :key="index" class="weather-list">
                            <div>{{item.date}}</div>
                            <div>{{item.week}}</div>
                            <div class="wea-text">
                                <img class="wea-text-img" :src="getImagePath(item.wea_day_img)" alt />
                                <div>{{item.wea_day}}</div>
                                <div>(日)</div>
                            </div>
                            <div class="wea-text">
                                <img class="wea-text-img" :src="getImagePath(item.wea_night_img)" alt />
                                <div>{{item.wea_night}}</div>
                                <div>(晚)</div>
                            </div>
                            <div class="wea-text-tem">{{item.tem}}
                                <span style="color: #adadad;font-size: 0.6rem;">℃</span>
                            </div>
                            <div class="wea-text-tem">
                                <span style="color: #5bff63;margin-left: 0.2rem">↑</span>
                                {{item.tem1}}
                                <span style="color: #adadad;font-size: 0.6rem;">℃</span>
                            </div>
                            <div class="wea-text-tem">
                                <span style="color: #fb1616;margin-left: 0.2rem">↓</span>
                                {{item.tem2}}
                                <span style="color: #adadad;font-size: 0.6rem;">℃</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="emergency-response">
                <div class="emergency">
                    <div class="emergency-subtitle">重要站点水情</div>
                    <div>
                        <div class="site-title">
                            <div>站点</div><div>实时水位(m)</div>
                            <div>警戒水位(m)</div><div>历史最高水位(m)</div>
                        </div>
                        <div style="height: 27vh; overflow: hidden;">
                            <div v-for="(item, index) in siteList" :key="index"  class="site-list">
                                <div>{{item.site}}</div><div>{{item.realWaterLevel}}</div>
                                <div style="color:#ff5f2e;font-weight: bolder">{{item.warmWaterLevel}}</div><div>{{item.highestWaterLevel}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="emergency">
                    <div class="emergency-subtitle">水情预警</div>
                    <div>
                        <waterConditionWarn/>
                    </div>
                </div>
                <div class="emergency">
                    <div class="emergency-subtitle">分区雨量统计</div>
                    <div>
                        <div class="site-title">
                            <div>区域</div><div>最大雨量(mm)</div>
                            <div>平均雨量(mm)</div><div>最大雨量点(m)</div>
                        </div>
                        <div style="height: 27vh; overflow: hidden;">
                            <div v-for="(item, index) in rainfallList" :key="index"  class="site-list">
                                <div>{{item.area}}</div><div>{{item.maxRainfall}}</div>
                                <div style="color: #00d4ff">{{item.averageRainfall}}</div><div>{{item.maxRainfallDot}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="emergency-response">
                <div class="emergency">
                    <div class="emergency-subtitle">城区重要泵站工况</div>
                    <div>
                        <div class="site-title">
                            <div>泵站名称</div><div>开机</div>
                            <div>装机</div><div>开机流量</div><div>装机流量</div>
                        </div>
                        <div style="height: 27vh; overflow: hidden;">
                            <div v-for="(item, index) in pumpList" :key="index"  class="site-list">
                                <div>{{item.pumpName}}</div><div>{{item.turnOn}}</div>
                                <div>{{item.turnOff}}</div><div>{{item.turnOnFlow}}</div><div>{{item.turnOffFlow}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="emergency-response-container">
            <!-- 河湖管理 -->
            <div class="emergency-title" ref="riverLakeManagement">
                <span class="icon"></span>
                <span class="text">河湖管理</span>
            </div>
            <div class="emergency-response">
                <div class="emergency">
                    <div class="emergency-subtitle">河湖数量统计</div>
                    <div>
                        <div class="site-title">
                            <div>区域</div><div>市级</div>
                            <div>县级</div><div>镇级</div><div>村级</div>
                        </div>
                        <div style="height: 27vh; overflow: hidden;">
                            <div v-for="(item, index) in pumpList" :key="index"  class="site-list">
                                <div>{{item.pumpName}}</div><div>{{item.turnOn}}</div>
                                <div>{{item.turnOff}}</div><div>{{item.turnOnFlow}}</div><div>{{item.turnOffFlow}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="emergency">
                    <div class="emergency-subtitle">河湖水质统计</div>
                    <div>
                        <riverWaterQuality/>
                    </div>
                </div>
                <div class="emergency">
                    <div class="emergency-subtitle">各地区黑臭水体统计</div>
                    <div>
                        <div class="site-title">
                            <div>区域</div><div>占比</div>
                        </div>
                        <div style="height: 27vh; overflow: hidden;">
                            <div v-for="(item, index) in pumpList" :key="index"  class="site-list">
                                <div>{{item.pumpName}}</div><div>{{item.turnOn}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="emergency-response">
                <div class="emergency">
                    <div class="emergency-subtitle">黑臭水体关联河道数量统计</div>
                    <div>
                        <div class="site-title">
                            <div>区域</div><div>总数量</div>
                            <div>已完成</div><div>未完成</div>
                        </div>
                        <div style="height: 27vh; overflow: hidden;">
                            <div v-for="(item, index) in pumpList" :key="index"  class="site-list">
                                <div>{{item.pumpName}}</div><div>{{item.turnOn}}</div>
                                <div>{{item.turnOff}}</div><div>{{item.turnOnFlow}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="emergency">
                    <div class="emergency-subtitle">各地区管理范围线面积统计</div>
                    <div>
                        <div class="site-title">
                            <div>区域</div><div>面积</div>
                        </div>
                        <div style="height: 27vh; overflow: hidden;">
                            <div v-for="(item, index) in pumpList" :key="index"  class="site-list">
                                <div>{{item.pumpName}}</div><div>{{item.turnOn}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="emergency">
                    <div class="emergency-subtitle">各地区规划蓝线面积统计</div>
                    <div>
                        <div class="site-title">
                            <div>区域</div><div>面积</div>
                        </div>
                        <div style="height: 27vh; overflow: hidden;">
                            <div v-for="(item, index) in pumpList" :key="index"  class="site-list">
                                <div>{{item.pumpName}}</div><div>{{item.turnOn}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="emergency-response">
                <div class="emergency">
                    <div class="emergency-subtitle">各地区告警事件统计</div>
                    <div>
                        <div class="site-title">
                            <div>区域</div><div>消除数</div>
                            <div>处理数</div><div>未处理数</div>
                        </div>
                        <div style="height: 27vh; overflow: hidden;">
                            <div v-for="(item, index) in pumpList" :key="index"  class="site-list">
                                <div>{{item.pumpName}}</div><div>{{item.turnOn}}</div>
                                <div>{{item.turnOff}}</div><div>{{item.turnOnFlow}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="emergency-title" ref="drainageManagement">
            <span class="icon"></span>
            <span class="text">排水管理</span>
        </div>
        <div class="emergency-response">
            <div class="emergency-index">
                <div class="emergency-subtitle">平台大数据</div>
                <div class="platform-data-container">
                    <div v-for="(item, index) in platformData" :key="index" class="platform-data-item">
                        <div class="platform-data-name">{{ item.name }}</div>
                        <div class="platform-data-text">
                            <div class="platform-data-num" :style="{ color: item.color }">{{ item.num }}</div>
                            <div class="platform-data-unit" :style="{ color: item.color }">{{ item.unit }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <BackgroundAnimation :particleCount="30"/>
    </div>
</template>
<script>
import {selectIndexNumList} from "@/views/diagnose/api/diagnose";
import waterConditionWarn from "@/views/index/components/waterConditionWarn.vue";
import riverWaterQuality from "@/views/index/components/riverWaterQuality.vue";
import BackgroundAnimation from '@/components/water-affairs-style/backgroundAnimation.vue';
export default {
    components:{
        BackgroundAnimation,waterConditionWarn,riverWaterQuality
    },
    data(){
        return{
            list:[
                {label:'日均供水量',value:10,unit:'万方/日',background:'linear-gradient(135deg, rgba(44, 94, 187, 0.8) 0%, rgba(28, 64, 138, 0.8) 100%)'},
                {label:'供水管网长度',value:214.17,unit:'千米',background:'linear-gradient(135deg, #106B53 0%, #074D3B 100%)'},
                {label:'日均污水处理量',value:8,unit:'万方/日',background:'linear-gradient(135deg, #4A367A 0%, #342358 100%)'},
                {label:'排水管网长度',value:0,unit:'千米',background:'linear-gradient(135deg, #A14040 0%, #7A2F2F 100%)'},
                {label:'污水管道长度',value:0,unit:'千米',background:'linear-gradient(135deg, #9fa140 0%, #73752d 100%)'},
                {label:'雨水管道长度',value:0,unit:'千米',background:'linear-gradient(135deg, #a1409d 0%, #5f1e5c 100%)'},
            ],
            numList:[],
            emergencyArea: [
                { item: '盱城街道', value: 0 },
                { item: '太和街道', value: 0 },
                { item: '古桑街道', value: 0 },
                { item: '马坝镇', value: 0 },
                { item: '官滩镇', value: 1 },
                { item: '桂五镇', value: 0 },
                { item: '管仲镇', value: 0 },
                { item: '河桥镇', value: 0 },
                { item: '鲍集镇', value: 0 },
                { item: '黄花塘镇', value: 0 },
                { item: '淮河镇', value: 0 },
                { item: '天泉湖镇', value: 0 },
                { item: '穆店镇', value: 0 }
            ],
            weatherList:[],
            tableColumns: [
                {key: 'site',title: '站点',field: 'site',infotype: 'text'},
                {key: 'realWaterLevel',title: '实时水位(m)',field: 'realWaterLevel',infotype: 'text'},
                {key: 'warmWaterLevel',title: '警戒水位(m)',field: 'warmWaterLevel',infotype: 'text'},
                {key: 'highestWaterLevel',title: '历史最高水位(m)',field: 'highestWaterLevel',infotype: 'text'},
            ],
            siteList:[
                {id:1,site:'水文站1',realWaterLevel:'23.5',warmWaterLevel:'17',highestWaterLevel:'15.84'},
                {id:2,site:'水文站2',realWaterLevel:'11.5',warmWaterLevel:'14',highestWaterLevel:'15.84'},
                {id:3,site:'水文站3',realWaterLevel:'14.5',warmWaterLevel:'15',highestWaterLevel:'15.84'},
                {id:4,site:'水文站4',realWaterLevel:'46.5',warmWaterLevel:'14',highestWaterLevel:'15.84'},
                {id:5,site:'水文站5',realWaterLevel:'17.5',warmWaterLevel:'13',highestWaterLevel:'15.84'},
                {id:6,site:'水文站6',realWaterLevel:'15.5',warmWaterLevel:'12',highestWaterLevel:'15.84'},
            ],
            rainfallList:[
                {area:'盱城街道',maxRainfall:15,averageRainfall:10,maxRainfallDot:4},
                {area:'太和街道',maxRainfall:13,averageRainfall:12,maxRainfallDot:5},
                {area:'古桑街道',maxRainfall:14,averageRainfall:11,maxRainfallDot:6},
                {area:'马坝镇',maxRainfall:12,averageRainfall:14,maxRainfallDot:4},
                {area:'官滩镇',maxRainfall:14,averageRainfall:12,maxRainfallDot:3},
                {area:'桂五镇',maxRainfall:15,averageRainfall:11,maxRainfallDot:5},
                {area:'管仲镇',maxRainfall:16,averageRainfall:12,maxRainfallDot:4},
                {area:'河桥镇',maxRainfall:14,averageRainfall:11,maxRainfallDot:6},
                {area:'鲍集镇',maxRainfall:13,averageRainfall:10,maxRainfallDot:5},
                {area:'黄花塘镇',maxRainfall:15,averageRainfall:12,maxRainfallDot:4},
                {area:'淮河镇',maxRainfall:15,averageRainfall:10,maxRainfallDot:5},
                {area:'天泉湖镇',maxRainfall:13,averageRainfall:11,maxRainfallDot:4},
                {area:'穆店镇',maxRainfall:11,averageRainfall:10,maxRainfallDot:4}
            ],
            pumpList:[
                {pumpName:'泵站1',turnOn:'1',turnOff:'2',turnOnFlow:'10',turnOffFlow:'12'},
                {pumpName:'泵站2',turnOn:'1',turnOff:'2',turnOnFlow:'10',turnOffFlow:'12'},
                {pumpName:'泵站3',turnOn:'1',turnOff:'2',turnOnFlow:'10',turnOffFlow:'12'},
                {pumpName:'泵站4',turnOn:'1',turnOff:'2',turnOnFlow:'10',turnOffFlow:'12'},
                {pumpName:'泵站5',turnOn:'1',turnOff:'2',turnOnFlow:'10',turnOffFlow:'12'},
                {pumpName:'泵站6',turnOn:'1',turnOff:'2',turnOnFlow:'10',turnOffFlow:'12'},
                {pumpName:'泵站7',turnOn:'1',turnOff:'2',turnOnFlow:'10',turnOffFlow:'12'},
                {pumpName:'泵站8',turnOn:'1',turnOff:'2',turnOnFlow:'10',turnOffFlow:'12'},
                {pumpName:'泵站9',turnOn:'1',turnOff:'2',turnOnFlow:'10',turnOffFlow:'12'},
                {pumpName:'泵站10',turnOn:'1',turnOff:'2',turnOnFlow:'10',turnOffFlow:'12'},
                {pumpName:'泵站11',turnOn:'1',turnOff:'2',turnOnFlow:'10',turnOffFlow:'12'},
                {pumpName:'泵站12',turnOn:'1',turnOff:'2',turnOnFlow:'10',turnOffFlow:'12'},
            ],
            platformData:[
                {name:'PC端功能',num:23,unit:'个',color:'#0761d3'},
                {name:'数据总览',num:624,unit:'',color:'#d100cd'},
                {name:'服务累计调用',num:218,unit:'次',color:'#fb8c00'},
                {name:'APP访问总量',num:119,unit:'次',color:'#00f8f8'},
                {name:'移动端功能',num:22,unit:'个',color:'#39ea00'},
                {name:'服务接口',num:143,unit:'个',color:'#6500ff'},
                {name:'用户数',num:178,unit:'人',color:'#ffb800'},
                {name:'WEB总访问量',num:23,unit:'次',color:'#00c1ff'}
            ],
            indexNumList:[]

        }
    },
    mounted() {
        this.getWeatherForeCast();
        this.selectIndexNumList();
        setTimeout(() => this.startScrolling(), 1000);
    },
    watch:{
        numList(newVal) {
            console.log(newVal)
        }
    },
    methods:{
        selectIndexNumList() {
            selectIndexNumList({}).then(res => {
                console.log("res:::", res);
                this.indexNumList = res.list;
                let sewageLength = 0;
                let rainLength = 0;

                this.indexNumList.forEach(item => {
                    if (item.typename === 'sewage') {
                        sewageLength = parseFloat(item.datanum);
                        this.list.find(entry => entry.label === '污水管道长度').value = (sewageLength / 1000).toFixed(2);
                    } else if (item.typename === 'rain') {
                        rainLength = parseFloat(item.datanum);
                        this.list.find(entry => entry.label === '雨水管道长度').value = (rainLength / 1000).toFixed(2);
                    }
                });

                // 更新排水管网长度
                this.list.find(entry => entry.label === '排水管网长度').value = ((sewageLength + rainLength) / 1000).toFixed(2);
            });
        },
        scrollToElement(refName) {
            const element = this.$refs[refName];
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        },
        beforeUnmount() {
            if (this.scrollTimer) clearInterval(this.scrollTimer);
        },
        startScrolling() {
            // 清除原有定时器，避免重复触发
            if (this.scrollTimer) clearInterval(this.scrollTimer);
            this.scrollTimer = setInterval(() => {
                const firstItem = this.siteList[0];
                this.siteList = [...this.siteList.slice(1), firstItem];
                const firstItem1 = this.rainfallList[0];
                this.rainfallList = [...this.rainfallList.slice(1), firstItem1];
                const firstItem2 = this.pumpList[0];
                this.pumpList = [...this.pumpList.slice(1), firstItem2];
            }, 2000);
        },

        backToTop(){
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        },
        getImagePath(name) {
            return `https://adm.ac.cn/static/img/weather/mango/${name}.png`;
        },
        getWeatherForeCast() {
            fetch("https://adm.ac.cn/Api/Weather/getForcast7?token=njszy&city=盱眙")
                .then((res) => res.json())
                .then((res) => {
                    if (res && res.info) {
                        this.updateTime = res.info.update_time;
                    }
                    if (res && res.info && Array.isArray(res.info.data)) {
                        this.weatherList = res.info.data;
                        console.log("this.weatherList::::",this.weatherList)
                    }
                });
        },
    }
}
</script>
<style scoped>
.banner {
    width: 100%;
    height: 25vh;
    background: url("/index/index1.png") no-repeat center center;
    background-size: 100% auto;
    background-attachment: fixed;

    /* 新增文字样式 */
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 2.5vw;
    font-weight: bold;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}
.layout-container {
    display: flex;
    position: relative;
    flex-direction: column;
    color: #fff;
}
.fixed-sidebar {
    position: fixed;
    left: 10px;
    top: 85%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    gap: 15px;
    z-index: 999;
    color: #adadad;
}
.sidebar-item {
    cursor: pointer;
    background: rgba(10, 20, 40, 0.6);
    padding: 0.5rem;
    border: 1px solid rgba(0, 255, 150, .2);
}
.sidebar-item:hover {
    color: #00ff96;
}
.emergency-title{
    width: 88%;
    margin: 0.5rem auto;
    font-size: 1.5rem;
    margin-top: 1rem;
}
.icon {
    display: inline-block;
    width: 15px;
    height: 24px;
    margin-right: 8px;
    background: #00bfff;
    clip-path: polygon(0 0, 100% 50%, 0 100%);
}

.text {
    font-weight: 500;
}
.emergency-response {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding: 20px;
    width: 90%;
    margin: auto;
}

.emergency {
    display: flex;
    flex-direction: column;
    /*align-items: center;*/
    width: calc(33.333% - 20px);
    padding: 10px;

    background: rgba(20, 35, 70, .5);
    border: 1px solid rgba(0, 255, 150, .2);
    border-radius: 16px;
    transition: all .3s ease;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.emergency-index{
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 10px;

    background: rgba(20, 35, 70, .5);
    border: 1px solid rgba(0, 255, 150, .2);
    border-radius: 16px;
    transition: all .3s ease;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.emergency-subtitle {
    font-size: 18px;
    margin-bottom: 10px;
    text-align: left;
    border-left: 0.5rem solid #00ff96;
    padding-left: 1rem;
    margin-left: 1rem;
}

.emergency:hover {
    transform: translateY(-5px);
    border-color: rgba(0, 255, 150, 0.5);
    box-shadow: 0 10px 30px rgba(0, 255, 150, 0.2);
}
.emergency-areas {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
}
.emergency-area-item {
    width: 25%;
    padding: 0.2vw;
    background-color: #0e182f;
    border: 1px solid #0f5053;
    border-radius: 5px;
    text-align: center;
    font-size: 1vw;
}
.emergency-area-item:hover{
    background-color: #2c9462;
    color: #0a0e27;
}
.emergency-area-item-status{
    font-size: 0.8rem;
    color: #adadad;
}

.emergency-duty{
    margin-top: 1.5rem;
}
.flood-control-duty{
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: auto;
}
.flood-control-duty-today,.flood-control-duty-tomorrow{
    width:49%;
    height: 2.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    font-weight: bolder;
}
.flood-control-duty-today{
    background: linear-gradient(135deg, #e8993e, #f35419);
}
.flood-control-duty-tomorrow{
    background: linear-gradient(135deg, #2d77ec, #003cab);
}
.flood-control-duty-detail{
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: auto;
    margin-top: 1rem;
}
.flood-control-duty-detail-item{
    width: 49%;
    font-size: 1.3rem;
    font-weight: bolder;
    text-align: center;
}
.flood-control-duty-detail-item > div{
    margin: 2rem;
}
.flood-control-duty-detail-item-name{
    font-size: 1rem;
    font-weight: normal;
}

.emergency-wea{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-left: 1rem;
    font-size: 1.2vw;
    color: #00d4ff;
}
.wea-area{
    color: #e6e6e6;
    font-size: 1.2vw;
}

.weather-list{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-left: 1rem;
    font-size: 0.7vw;
}
.weather-list > div{
    margin: 0.5rem 0;
}
.wea-text{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 15%;
}
.wea-text-img{
    width: 0.8vw;
}
.wea-text-tem{
    width: 10%;
}
/* 表格标题样式 */
.site-title {
    display: flex;
    width: 100%;
    font-size: 0.7vw;
    color: #00ff96;
    background: rgba(10, 20, 40, 0.6);
    border-bottom: 2px solid rgba(0, 255, 150, 0.3);
    padding: 0.8rem 0;
}
/* 表格内容行样式 */
.site-list {
    display: flex;
    width: 100%;
    font-size: 0.7vw;
    padding: 0.6rem 0;
    border-bottom: 1px solid rgba(0, 255, 150, 0.1);
}
/* 统一列宽（4列平均分配） */
.site-title > div, .site-list > div {
    flex: 1;
    text-align: center;
    padding: 0 0.5rem;
}










.index-content{
    display: inline-flex;
    width: 100%;
    justify-content: center;
    align-items: center;
}

.index-img-div1 {
    width: 60%;
    min-width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
    height: 80vh;
}

.menu-info-content{
    margin-top: 20%;
}
.index-img1{
    height: 55vh;
    margin-top: 30px;
}
.menu-info{
    position: absolute;
    height: 50vh;
    width: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}

.menu-bg{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #fff;
    cursor: pointer;
    transition: transform 0.2s ease;
    position: absolute;
    padding: 0 5px;
}
.menu-bg::after{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}
.menu-bg span{
    position: relative;
    z-index: 2;
}
.float-animation {
    animation: float 3s ease-in-out infinite;
}
@keyframes float {
    0% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
    100% { transform: translateY(0); }
}
.menu-bg:hover{
    transform: scale(1.05);
    animation-play-state: paused;
}

.index-top-content{
    position: absolute;
    display: flex;
    justify-content: space-around;
    width: 65%;
}
.index-top-item {
    width: 15vw;
    color: #fff;
    padding: 0.8rem 0.5rem;
    margin: 0 1rem;
    position: relative;
    background: transparent; /* 设置背景为透明 */
    border-radius: 8px; /* 添加圆角效果 */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* 添加阴影效果 */
}

.index-top-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1; /* 确保背景在内容下方 */
    background: linear-gradient(45deg, transparent 0%, rgba(255, 255, 255, 0.08) 100%);
    border-radius: 8px; /* 保持与父元素相同的圆角 */
}

.index-top-item-value{
    margin: 0.2rem 0;
}

.index-top-item-value{
    font-weight: 600;
    font-size: 1.3rem;
}

.index-top-item-label{
    color: #fff;
}
.index-top-item-value{
    font-weight: 600;
    font-size: 1.3rem;
    margin: 0.2rem 0;
}

/*平台大数据*/
.platform-data-container{
    display: flex;
    justify-content: space-around;
    font-size: 1.2rem;
    margin: 1rem 0;
    width: 100%;
}
.platform-data-text{
    display: flex;
    justify-content: start;
    align-items: center;
    margin-top: 1rem;
    font-size: 1.5rem;
    font-weight: bolder;
}

</style>